import { FC, MutableRefObject } from 'react';
import { Link } from 'react-router-dom';
import i18n from 'i18n';
import styles from './CreateAndFilter.module.scss';
import { hasFuncs } from 'core/permission/PermissionDSL';
import { Permission } from 'core/auth/Permission';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import { SearchBar } from 'components/SearchBar';
import {
  FilterMenuTab,
  FilterMenuTabConfig,
} from 'components/FilterMenuTab/FilterMenuTab';

interface CreateAndFilterType {
  searchBarRef: MutableRefObject<SearchBar>;
  filterMenuTabConfigs: FilterMenuTabConfig[];
  onSearch: (searchString: string) => void;
  searchString: string;
}

const CreateAndFilter: FC<CreateAndFilterType> = ({
  searchBarRef,
  filterMenuTabConfigs,
  onSearch,
  searchString,
}) => {
  return (
    <div className={styles['create-and-filter']}>
      <PermissionChecker permissionAware={hasFuncs(Permission.ORDER_WRITE)}>
        <Link to='/orders/new' className='btn btn-tertiary btn-sm'>
          {i18n.t<string>('orders.labels.newOrder')}
        </Link>
      </PermissionChecker>
      <FilterMenuTab filterMenuTabConfigs={filterMenuTabConfigs} />
      <SearchBar
        ref={searchBarRef}
        model={{
          placeholder: i18n.t<string>('orderList.placeholders.searchbar'),
          search: onSearch,
          defaultValue: searchString,
        }}
      />
    </div>
  );
};

export default CreateAndFilter;
